import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";
import getHomepage from "../../utils/getHomepage";
import logoDE from "../../assets/images/logo_color_de.png";
import logoEN from "../../assets/images/logo_color_en.png";

const LogoImage = Scrivito.connect(() => {
  const currentPage = Scrivito.currentPage();
  const ancestors = [...(currentPage.ancestors() || []), currentPage];
  const logo = I18n.resolvedLanguage === "de" ? logoDE : logoEN;
  let altLogo = null;

  if (ancestors) {
    const logos = ancestors.reverse().map((o) => o?.get("logo"));
    altLogo = logos.filter((l) => l)?.[0];
  }

  const url = altLogo ? Scrivito.urlFor(altLogo) : logo;

  return (
    <img
      src={url}
      className="img-fluid"
      alt={I18n.t("layout.logoAltText")}
      width="136"
      height="45"
    />
  );
});

const NoLinkLogo = () => (
  <span className="navbar-brand">
    <LogoImage />
  </span>
);

const Logo = ({ className, currentPage }) => {
  if (!currentPage) {
    return <NoLinkLogo />;
  }
  const homepage = getHomepage(currentPage);
  if (!homepage) {
    return <NoLinkLogo />;
  }
  return (
    <Scrivito.LinkTag
      to={homepage}
      className={`navbar-brand ${className || ""}`}
      title="Homepage"
    >
      <LogoImage />
    </Scrivito.LinkTag>
  );
};

export default Scrivito.connect(Logo);
